import React from 'react';
import { List } from 'components/List';
import { StationData } from 'domain/models/cards.model';
import { decimals, isOdd } from 'domain/utils';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { DATE_TIME_S_FORMAT } from 'domain/utils/time.utils';

export const ObservationsList = ({ data }: { data?: StationData[] }) => {
	const { t } = useTranslation(['labels', 'variables']);
	return (
		<List size='sm'>
			<List.RowGroup>
				<List.Row>
					<List.Header className='w-4/12'>{t('labels:date')}</List.Header>
					<List.Header className='w-2/12'>{t('variables:tas')}</List.Header>
					<List.Header className='w-2/12'>{t('variables:pr')}</List.Header>
					<List.Header className='w-2/12'>{t('variables:sfcwind')}</List.Header>
					<List.Header className='w-2/12'>{t('variables:wgust')}</List.Header>
					<List.Header className='w-2/12'>{t('variables:hurs')}</List.Header>
				</List.Row>
				<List.RowGroup className='max-h-[80px] overflow-y-scroll'>
					{data &&
						data.map((observation, index) => {
							return (
								<List.Row
									key={`${index}-${observation.timestamp}`}
									className={!isOdd(index) ? 'border-none bg-gray-100' : ''}>
									<List.Cell className='w-4/12'>
										{format(
											new Date(observation.timestamp),
											DATE_TIME_S_FORMAT
										)}
									</List.Cell>
									<List.Cell className='w-2/12'>
										{t('labels:temp_units', {
											unit: decimals(observation.data.tas, 1),
										})}
									</List.Cell>
									<List.Cell className='w-2/12'>
										{t('labels:precip_units', {
											unit: decimals(observation.data.pr, 1),
										})}
									</List.Cell>
									<List.Cell className='w-2/12'>
										{t('labels:wind_units', {
											unit: decimals(observation.data.sfcwind, 1),
										})}
									</List.Cell>
									<List.Cell className='w-2/12'>
										{t('labels:wind_units', {
											unit: decimals(observation.data.wgust, 1),
										})}
									</List.Cell>
									<List.Cell className='w-2/12'>
										{t('labels:humidity_units', {
											unit: decimals(observation.data.hurs, 1),
										})}
									</List.Cell>
								</List.Row>
							);
						})}
				</List.RowGroup>
			</List.RowGroup>
		</List>
	);
};
export default ObservationsList;
